export default {
  data: () => ({
    isHeaderHidden: false,
    rootEl: null,
    headerEl: null,
    siteHeaderEl: null,
    rafId: null,
  }),

  mounted() {
    this.$nextTick(() => {
      this.initializeHeaderHiding();
    });
  },

  beforeDestroy() {
    this.cleanup();
  },

  methods: {
    initializeHeaderHiding() {
      // Cache all DOM elements once
      this.rootEl = document.querySelector(".center-search");
      this.headerEl = document.querySelector("header");
      this.siteHeaderEl = document.querySelector(".site-header");

      if (!this.rootEl) return;

      window.addEventListener("scroll", this.throttledScrollCheck, {
        passive: true,
      });
    },

    isOverlapping() {
      if (!this.siteHeaderEl || !this.$el) return false;

      const headerRect = this.siteHeaderEl.getBoundingClientRect();
      const targetRect = this.$el.getBoundingClientRect();
      const searchResult = document.querySelector(".search-bar-result");

      return (
        targetRect.top <= headerRect.bottom + 5 &&
        targetRect.bottom >= headerRect.top - 5 &&
        targetRect.left < headerRect.right &&
        targetRect.right > headerRect.left &&
        (!searchResult || searchResult.offsetParent === null)
      );
    },

    throttledScrollCheck() {
      // Cancel previous frame if it hasn't executed yet
      if (this.rafId) return;

      this.rafId = requestAnimationFrame(() => {
        this.$nextTick(() => {
          this.toggleHeader(this.isOverlapping());
          this.rafId = null;
        });
      });
    },

    toggleHeader(shouldHide) {
      if (this.isHeaderHidden === shouldHide) return;

      this.isHeaderHidden = shouldHide;

      requestAnimationFrame(() => {
        if (!this.rootEl || !this.headerEl) return;

        if (shouldHide) {
          this.headerEl.classList.remove("h-32");
          this.headerEl.classList.add("h-20");
          this.rootEl.classList.add("hidden");
        } else {
          this.headerEl.classList.add("h-32");
          this.headerEl.classList.remove("h-20");
          this.rootEl.classList.remove("hidden");
        }
      });
    },

    cleanup() {
      // Cancel any pending animation frame
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }

      window.removeEventListener("scroll", this.throttledScrollCheck, {
        passive: true,
      });

      // Reset DOM state if elements exist
      if (this.rootEl && this.headerEl) {
        this.headerEl.classList.remove("h-20");
        this.headerEl.classList.add("h-32");
        this.rootEl.classList.remove("hidden");
      }

      // Clear references
      this.rootEl = null;
      this.headerEl = null;
      this.siteHeaderEl = null;
    },

    reinitialize() {
      this.cleanup();
      this.$nextTick(() => {
        this.initializeHeaderHiding();
      });
    },
  },
};
